import React, { useEffect, createElement } from 'react';
import AdvertorialGlpInvestigationE from '../components/AdvertorialGlpInvestigationE';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpInvestigationEPage() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv2
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Ozempic Depression Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'ReadHalfArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'ReadFullArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18604" data-mp="13yks4ihgin7g">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18605" data-mp="13z47psjmwzib">
        <Helmet data-id="element-18606" data-mp="140nsnwg8jyqf">
          <title data-id="element-18607" data-mp="pa85wd868iq5">GLP-1 & MENTAL HEALTH - MAJOR BREAKTHROUGH</title>
          <meta property="og:title" content="GLP-1 & MENTAL HEALTH - MAJOR BREAKTHROUGH" data-id="element-18608" data-mp="p7vdf64sepyu" />
          <meta property="og:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18609" data-mp="u9awwtrbgof4" />
          <meta property="og:type" content="article" data-id="element-18610" data-mp="1nco8c7a0he9" />
          <meta property="og:url" content={window.location.href} data-id="element-18611" data-mp="3st49oya3z5uq" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18612" data-mp="3suyw6h11360x" />
          <meta property="og:image:width" content="1200" data-id="element-18613" data-mp="6l4l7kms2tpb" />
          <meta property="og:image:height" content="630" data-id="element-18614" data-mp="6nqrzi1uh56h" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18615" data-mp="kkdue0ckgnjs" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18616" data-mp="fn464o0wyhxj" />
          <meta name="twitter:title" content="GLP-1 DEPRESSION: REAL SIDE EFFECT OR COINCIDENCE?" data-id="element-18617" data-mp="fkhvugmn1obm" />
          <meta name="twitter:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18618" data-mp="pc5kk9rt8r9e" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18619" data-mp="yar1k0hmvy82" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18620" data-mp="2ss97t7zo0xa2" />
        </Helmet>
        <AdvertorialGlpInvestigationE data-id="element-18621" data-mp="32j3qk2dpdeqr" />
      </div>
    </HelmetProvider>;
}